import { setGlobalStoreCookie } from '@/stores/global.store';

const ORIGIN_KEY = '__impersonation_origin';

type Origin = {
	token: string;
	selectedCompanyID: string | null;
};

export function saveImpersonationOrigin(origin: Origin) {
	sessionStorage.setItem(ORIGIN_KEY, JSON.stringify(origin));
}

export function readImpersonationOrigin(): Origin | null {
	const raw = sessionStorage.getItem(ORIGIN_KEY);
	if (!raw) return null;
	try {
		return JSON.parse(raw) as Origin;
	} catch {
		return null;
	}
}

export function clearImpersonationOrigin() {
	sessionStorage.removeItem(ORIGIN_KEY);
}

export function swapAuthCookie(token: string, selectedCompanyID: string | null) {
	setGlobalStoreCookie(() => ({ token, selectedCompanyID }));
}
